import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import classNames from "classnames"
import { Grow, Paper, IconButton, TextField, InputAdornment, List, ListItemButton, Divider, ListItemText, ClickAwayListener, ListItemIcon, Collapse } from "@mui/material"
import { Dns, Search, Add } from "@mui/icons-material"
import WatchlistMenuItem from "./components/watchlists-menu-item"
import EditWatchlist from "components/edit-watchlist"
import Tooltip from "components/material/tooltip"
import "./style.scss"

class WatchlistsMenu extends Component {
  static propTypes = {
    menuVisible: PropTypes.bool.isRequired,
    resetMenu: PropTypes.func.isRequired,
    createWatchlist: PropTypes.func.isRequired,
    toggleMenu: PropTypes.func.isRequired,
    watchlists: PropTypes.array.isRequired,
    searchWatchlists: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    securities: PropTypes.object,
    selectWatchlist: PropTypes.func.isRequired,
    selectedWatchlists: PropTypes.array,
    addToWatchlists: PropTypes.func.isRequired,
    supportsRestoringDeleting: PropTypes.bool,
    applyButtonEnabled: PropTypes.bool,
    defaultSelectedWatchlists: PropTypes.array,
    security: PropTypes.object,
    toggleFromWatchlists: PropTypes.func,
    updated: PropTypes.bool,
    right: PropTypes.bool,
    creatingWatchlist: PropTypes.bool,
    toggleCreatingWatchlist: PropTypes.func,
    fontSize: PropTypes.string,
    heapCreateWatchlistId: PropTypes.string,
    heapAddToWatchlistId: PropTypes.string,
    asOf: PropTypes.string,
    modelId: PropTypes.string.isRequired,
  }

  static defaultProps = {
    selectedWatchlists: [],
  }

  componentDidUpdate(oldProps) {
    if (this.props.updated && !oldProps.updated) {
      this.props.toggleMenu()
    }
  }

  search = ({ target: { value } }) => {
    const { searchWatchlists } = this.props
    searchWatchlists(value)
  }

  selectWatchlist = (id) => {
    const { selectWatchlist, supportsRestoringDeleting, defaultSelectedWatchlists } = this.props
    if (supportsRestoringDeleting) {
      selectWatchlist(id, defaultSelectedWatchlists)
    } else {
      selectWatchlist(id)
    }
  }

  addToWatchlists = () => {
    const { addToWatchlists, selectedWatchlists, securities, toggleFromWatchlists, modelId, defaultSelectedWatchlists, security, supportsRestoringDeleting, asOf } = this.props

    if (supportsRestoringDeleting) {
      toggleFromWatchlists(selectedWatchlists, defaultSelectedWatchlists, security, asOf, modelId)
    } else {
      addToWatchlists(selectedWatchlists, securities, undefined, asOf)
    }
  }

  saveWatchlist = (id, data) => {
    const { securities, security, createWatchlist, asOf } = this.props
    let watchlistSecurities = {}

    if (securities) {
      watchlistSecurities = { ...securities }
    }

    if (security) {
      watchlistSecurities[security.id] = security
    }

    createWatchlist(data.name, data.description, watchlistSecurities, asOf)
  }

  handleClose = () => {
    const { toggleMenu, resetMenu } = this.props
    resetMenu()
    toggleMenu()
  }

  render() {
    const { menuVisible, right, toggleMenu, watchlists, searchValue, selectedWatchlists, applyButtonEnabled, supportsRestoringDeleting, fontSize, creatingWatchlist, toggleCreatingWatchlist, heapCreateWatchlistId, heapAddToWatchlistId } = this.props
    const title = supportsRestoringDeleting ? "Watchlist - Add / Remove Security" : "Add Selection To Watchlist"
    return <ClickAwayListener onClickAway={menuVisible ? this.handleClose : () => {}}>
      <div className="modules_watchlists-menu">
        <Tooltip title={title}>
          <IconButton
            onClick={toggleMenu}
            className="watchlist-toggle"
            size="large"
          >
            <Dns fontSize={fontSize} />
          </IconButton>
        </Tooltip>
        <Grow in={menuVisible} style={{ transformOrigin: right ? "top right" : "top left" }}>
          <Paper elevation={8} className={classNames("watchlists-menu", { open: menuVisible, right })}>
            <div className="menu-title">{title}</div>
            <div className="search-field">
              <TextField
                variant="standard"
                fullWidth
                value={searchValue}
                placeholder="Search..."
                onChange={this.search}
                color="secondary"
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>
            <List className="watchlists">
              {map(watchlists, (watchlist, i) =>
                <WatchlistMenuItem key={i} checked={selectedWatchlists.indexOf(watchlist.id) >= 0} onClick={this.selectWatchlist} id={watchlist.id} name={watchlist.name} />,
              )}
              {watchlists.length === 0 && <ListItemButton disabled>
                <ListItemText primary={searchValue ? "No watchlists matching this search" : "No watchlists found for this account"} />
              </ListItemButton>}
            </List>
            <Divider />
            <List disablePadding>
              {applyButtonEnabled && watchlists.length > 0 && <>
                <ListItemButton className="add-to-watchlist" id={heapAddToWatchlistId} onClick={this.addToWatchlists}>
                  <ListItemText primary="Apply" />
                </ListItemButton>
                <Divider />
              </>}
              {!applyButtonEnabled
                && <ListItemButton onClick={toggleCreatingWatchlist}>
                  <ListItemIcon>
                    <Add />
                  </ListItemIcon>
                  <ListItemText primary="Create new watchlist" />
                </ListItemButton>}
              <Collapse in={creatingWatchlist} timeout="auto" unmountOnExit>
                <EditWatchlist heapSubmitId={heapCreateWatchlistId} saveWatchlist={this.saveWatchlist} close={toggleCreatingWatchlist} />
              </Collapse>
            </List>
          </Paper>
        </Grow>
      </div>
    </ClickAwayListener>
  }
}

export default WatchlistsMenu
